export default __webpack_public_path__ + "static/GDSC-0c394c172a075a8e19b55ecf96030511.png";